export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14450.3f64fc2b.jpg";